export default __webpack_public_path__ + "static/media/signUp1.8c0caa29.jpg";